import React from 'react';
import './HospitalTable.scss'
import { Icon } from '@mui/material';
const HospitalTable = ({
  data
}) => {
  const info= data.data.hospitals;
  return (
    <table className="rounded-table">
      <thead>
        <tr className="hospital-table">
          <th>Hospital Name</th>
          <th>City</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {info.map((row, index) => (
          <tr key={index}>
            <td>{row.name}</td>
            <td>{row.city?.name}</td>
            <td>
              <div className="icon-container">
                <Icon className="icon">visibility</Icon>
                <Icon className="icon">edit</Icon>
                <Icon className="icon">delete</Icon>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default HospitalTable;